import React, { useEffect, useState } from 'react';
import UseFetchPost from './components/shared/useFetchPost';
import { devOrProd } from './components/shared/utils';
import { blackFridayLandingPage } from './components/shared/jsonData';
import './styles/app.scss';

// COMPONENTS
//import Hero from './components/Hero';
//import Editorial from './components/Editorial';
import NewArrivals from './components/NewArrivals';
import HeroVideoBackground from './components/HeroVideoBackground';
//import Storyly from './components/Storyly';

const App = () => {
  const [componentData, setComponentData] = useState({});

  // GET DATA FROM NQ
  const getData = UseFetchPost(
    blackFridayLandingPage.endPointUrl,
    blackFridayLandingPage.endPointPrams
  );

  // API DATA
  useEffect(() => {
    if (getData && getData.data) {
      let content = getData.data.content.content;
      let tempComponentData = {
        hero: content[0].data.black_friday_hero_block_reference,
        editorialFeature: content[1].data.black_friday_editoral_block_reference,
        editorialCards:
          content[2].data.black_friday_editoral_small_block_reference,
        heroVideo: content[3].data.seven_video_hero_container
      };
      setComponentData(tempComponentData);
    }
  }, [getData]);

  return (
    <section className="font-sans text-base font-base tracking-widest">
      {/* Fix to remove extra spacing on test site */}
      {devOrProd === 'dev' && (
        <style>
          {'div.main:not(.localhost) {padding-top: 11px !important;}'}
        </style>
      )}

      {/* Hero - Video Background */}
      <HeroVideoBackground
        data={componentData.heroVideo}
        gaBlockName={'Hero Video'}
        showHeroVideoBackground={true}
        topMargin={false}
        isLoop={true}
        isAutoPlay={true}
        isControls={false}
        isMuted={true}
      />

      {/* Hero */}
      {/*
        <Hero
          data={componentData.hero}
          topMargin={false}
          gaBlockName={'Hero Carousel'}
          singleHero={true} // Change to 'true' or 'false' to Show / Hide multiple Slides
          showHero={true}
          ShowHeroTextDescriptionButton={true} // Change to 'true' or 'false' to Show / Hide Text & Button
        />
      */}

      {/* Storyly - Not sure if needed so left in for now */}
      {/*<Storyly
        storylyToken="eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJhY2NfaWQiOjU3NzcsImFwcF9pZCI6MTE0NTUsImluc19pZCI6MTIyMzR9.b-keMHACgsvKeHCC2qumUjcZop550-rWBcKjeM-J42A"
        storylyHeading="Sevenstore Stories"
      />*/}

      <NewArrivals
        gaBlockName={'Black Friday Carousel'}
        gaBlockNameClothing={'Black Friday Carousel Clothing'}
        gaBlockNameFootwear={'Black Friday Carousel Footwear'}
        gaBlockNameAccessories={'Black Friday Carousel Accessories'}
        blackFriday={false}
        newArrivalsHeading={'Cyber Week 25% off with code BF25'}
        newArrivalsSubHeading={'Download the app for early access'}
      />

      {/* Editorial - Feature Large */}
      {/*
        <Editorial
          data={componentData.editorialFeature}
          featureLayout={true}
          gaBlockName={'Black Friday Feature Large'}
          showFeatureLayoutEditorial={true}
        />
      */}

      {/* Editorial - Feature Small */}
      {/*
        <Editorial
          data={componentData.editorialCards}
          gaBlockName={'Black Friday Feature Small'}
          showSmallLayout={true}
        />
      */}
    </section>
  );
};

export default App;
